import React from 'react'
import { Modal, Button } from '@sainsburys-tech/fable'
import { PropTypes } from 'prop-types'

const deletePassModal = (props) => {
  const {
    open,
    rejectClicked,
    acceptClicked,
    pass
  } = props

  const passName = pass && pass.name ? pass.name : null
  const confirmationText = passName
    ? `Are you sure you want to delete the ${passName} pass?`
    : 'Are you sure you want to delete this pass?'

  return (
    <Modal
      header={{
        label: 'Delete pass',
        isDismissible: true,
      }}
      isOpen={open}
      onClose={rejectClicked}
    >
      <div className="dsib-deletePassModal__body">
        <p className="dsib-deletePassModal__text">
          {confirmationText}
        </p>

        <div className="dsib-deletePassModal__actions">
          <Button type="button" variant="secondary" onClick={rejectClicked}>
            No, keep this pass
          </Button>
          <Button type="button" variant="primary" onClick={() => acceptClicked(pass)}>
            Yes, delete this pass
          </Button>
        </div>
      </div>
    </Modal>
  )
}

deletePassModal.propTypes = {
  open: PropTypes.bool.isRequired,
  rejectClicked: PropTypes.func.isRequired,
  acceptClicked: PropTypes.func.isRequired,
  pass: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
}

export default deletePassModal
